import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import 'shepherd.js/dist/css/shepherd.css';
import VueGtag from "vue-gtag-next";

const app = createApp(App)
app.use(store)
app.use(router)
app.use(VueGtag, {
  property: {
    id: "G-9NWTC14EGK"
  }
});

app.mount("#app")